@import '../../../globals/main.scss';

pn-dropdown-choice-adds-row {
  display: block;
  width: 80rem;

  .pn-row-select-dropdown {
    width: 50%;
    margin-bottom: 1rem;
  }

  @media only screen and (max-width: 640px) {
    .pn-row-select-dropdown {
      width: 100%;
    }
  }

  .pn-dropdown-choice-table {
    width: 100%;
    border-spacing: 0rem;
    border: none !important;

    thead {
      th {
        text-align: left;
        padding: 1rem 0.5rem;

        label {
          color: $gray700;
          font-size: 1.4rem;
          font-weight: 400;
        }
      }
    }
    
    .generated-table-row {
      display: flex;
      margin-bottom: 2rem;
    }

    .table-header {
      display: flex;
      margin: 2rem 0 3rem 0;
      font-weight: 500;
    }

    .table-header, .tr {
      &-dropdown, &-column, &-name {
        padding-right: 0.5rem;
        width: 35%;

        pn-select {
          width: 95%;
        }
      }

      &-input {
        width: 15%;

        pn-input {
          width: 100%;
        }
      }

      &-delete {
        margin: 1rem;
        width: 15%;
      }
    }

    tbody {
      td {
        padding: 0.5rem;
      }

      tr:nth-child(even) {
        background-color: #effbff;
      }

      .tr-delete {
        text-align: center;
      }
    }

    tfoot {
      td {
        small {
          color: $warning;
          vertical-align: middle;
        }

        pn-icon {
          margin-right: 0.25em;
          vertical-align: middle;
        }
      }
    }
  }
}
